import { ContentTypes, WorkspaceIds } from 'common/store/common/constants';


const contextService = {
    isContentTypeQuestion<T extends string>(typesArray: T[], option: T): boolean {
        return typesArray.some((type) => type?.includes(option));
    },

    isContentTypeSection(contentType: string): boolean {
        return contentType === ContentTypes.SECTION;
    },

    isWorkspaceAuthorEdit(workspaceId: string): boolean {
        return workspaceId === WorkspaceIds.AUTHOR_EDIT;
    },
};

export default contextService;
